import React from 'react';
import Headers from '../Headers';

const StoreHeader = ({ settings, storeName, isPreview }) => {
    return <Headers storeName={storeName} isPreview={isPreview} customSettings={settings} />;
};

export default StoreHeader;
